export enum ConsumableUnitEnum {
  Piece = 1,
  Meter = 2,
}
